import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export const handleDailySaleReportExcelExport = (saleItems) => {
  if (!saleItems || saleItems.length === 0) return;

  const worksheetData = saleItems.map((item) => ({
    "Order Date": item.orderDate,
    "Orders Count": item.ordersCount,
    "Product Total": item.productTotal,
    "Shipping Total": item.shippingTotal,
    "Handling Fee": item.handlingFeeTotal,
    "Order Total": item.orderTotal,
    "BV Total": item.bvTotal,
    "CP Total": item.cpTotal,
  }));

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Daily Sale Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(data, `Daily_Sale_Report_${new Date().toLocaleDateString()}.xlsx`);
};
